import SparkMD5 from 'spark-md5';

export const generateChecksum = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const chunkSize = 2 * 1024 * 1024; // 2MB
    const chunkCount = Math.ceil(file.size / chunkSize);
    let chunkIndex = 0;
    const md5Buffer = new SparkMD5.ArrayBuffer();
    const fileReader = new FileReader();

    const readNextChunk = (): void => {
      const start = chunkIndex * chunkSize;
      const end = Math.min(start + chunkSize, file.size);
      const bytes = file.slice(start, end);

      fileReader.readAsArrayBuffer(bytes);
      chunkIndex += 1;
    };

    fileReader.onload = (event: ProgressEvent<FileReader>): void => {
      const result = event.target?.result;
      if (result instanceof ArrayBuffer) {
        md5Buffer.append(result);
      }

      if (chunkIndex < chunkCount) {
        readNextChunk();
      } else {
        const binaryDigest = md5Buffer.end(true);
        const base64digest = btoa(binaryDigest);
        resolve(base64digest);
      }
    };

    fileReader.onerror = (): void => {
      reject(new Error(`Error reading ${file.name}`));
    };

    readNextChunk();
  });
};
